import _ from "lodash";
import React from "react";
// react component for creating dynamic tables
import ReactTable from "react-table";
import { NavLink } from "react-router-dom";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import extendedTablesStyle from "assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.js";
// @material-ui/icons
import Accounts from "@material-ui/icons/People";
import UserDetails from "@material-ui/icons/Ballot";
import LinkOff from "@material-ui/icons/LinkOff";
// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import CardIcon from "components/Card/CardIcon.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import IconButton from "@material-ui/core/IconButton";
import Loading from "../../components/Loading/Loading";
import { Select, InputLabel } from "@material-ui/core";
import MenuItem from "@material-ui/core/MenuItem";
import Tooltip from "@material-ui/core/Tooltip";
import UnbindFromSystem from '../../components/UnbindFromSystem/UnbindFromSystem';
import SweetAlert from 'react-bootstrap-sweetalert';
import { sweetAlertStyle } from '../../helpers/CustomStyles';
import "./AccountsReactTable.css";

// actions
import {
  accountsLoading,
  accountsLoaded,
  getVisibleAccounts,
} from "../../stores/actions/actions";
import { detachAccountFromSystemByID } from '../../stores/actions/accountActions';
import { getSystems2 } from '../../stores/actions/actions';
import { loaderStyleEmptyCard } from "../../helpers/CustomStyles";

const containsFilter = (filter, row) => {
  const value = row[filter.id];
  if (value === undefined || value === null) {
    return true;
  }
  return String(value).toLowerCase().includes(String(filter.value).toLowerCase());
};

const mobileColumns = [
  { Header: "" },
  {
    Header: "Name",
    accessor: "name",
    filterMethod: containsFilter,
  },
  { Header: "" },
  {
    Header: "Email",
    accessor: "email",
    filterMethod: containsFilter,
  },
  { Header: "" },
  {
    Header: "Phone",
    accessor: "phone",
    filterMethod: containsFilter,
  },
  { Header: "" },
  {
    Header: "Actions",
    accessor: "actions",
    sortable: false,
  },
];

const desktopColumns = [
  {
    Header: "Name",
    accessor: "name",
    filterMethod: containsFilter,
  },
  {
    Header: "Email",
    accessor: "email",
    filterMethod: containsFilter,
  },
  {
    Header: "Phone",
    accessor: "phone",
    filterMethod: containsFilter,
  },
  {
    Header: "Actions",
    accessor: "actions",
    sortable: false,
  },
];

class AccountsReactTable extends React.Component {
  state = {
    alert: null,
    pickedSystemId: "all",
    mobileTableSize: 10,
    currentDesktopTableSize: 20,
  };

  componentWillMount() {
    this.props.accountsLoading();
    Promise.all([this.props.getVisibleAccounts(), this.props.getSystems2()])
      .then(() => {
        let ids = [];
        this.props.accounts.forEach((a) => {
          ids.push(a.id);
        });
        const queryParams = new URLSearchParams(this.props.location.search); 
        const systemParam = queryParams.get("system");
        if (systemParam) {
          const systemId = parseInt(systemParam)
          const systemExists = this.props.systems && this.props.systems.some(system => system.ID === systemId);
          if (!isNaN(systemId) && systemExists) {
            this.setState({ pickedSystemId: systemId });
          } else {
            const searchParams = new URLSearchParams(this.props.location.search);
            searchParams.delete('system');
            this.props.history.push(`${this.props.location.pathname}?${searchParams.toString()}`);
          }
        }
      })
      .then(() => {
        this.props.accountsLoaded();
      });
  }

  componentDidMount() {
    const { mobileView } = this.props;
    if (mobileView) {
      this.onChangeToMobileView();
    }
    if (!mobileView) {
      this.onChangeToDesktopView();
    }
  }

  componentDidUpdate() {
    const { mobileView, accounts, currentDesktopTableSize } = this.props;
    if (mobileView) {
      this.onChangeToMobileView();
    }
    if (!mobileView) {
      this.onChangeToDesktopView();
    }
    const select = document.querySelector("select");
    if (accounts && accounts.length && select) {
      select.addEventListener("change", (e) => {
        if (currentDesktopTableSize !== parseInt(e.target.value)) {
          const currentValue = parseInt(e.target.value);
          this.setState({ currentDesktopTableSize: currentValue });
        }
      });
    }
  }

  onChangeToMobileView = () => {
    const tableHeader = document.querySelector(".rt-tr");
    if (tableHeader !== null) {
      tableHeader.style.display = "none";
    }
    const accountsRows = [...document.querySelectorAll(".ReactTable .rt-table .rt-tbody .rt-tr-group .rt-tr")];
    const rows = [...document.querySelectorAll(".ReactTable .rt-table .rt-tbody .rt-tr-group .rt-tr .rt-td")];
    const headers = [...document.querySelectorAll(".rt-tr .rt-th")];
    const descriptions = ["Name: ", "Email: ", "Phone: ", "Actions: "];
    let counter = 0;

    //enable content columns:
    rows.forEach((row, i) => {
      if (i % 2 === 0) {
        row.style.display = "initial";
        row.textContent = descriptions[counter];
        row.style.fontWeight = "500";
        counter++;
        if (counter === descriptions.length) {
          counter = 0;
        }
      }
    });
    //enable header columns:
    headers.forEach((header, i) => {
      if (i % 2 === 0) {
        header.style.display = "initial";
      }
    });
    //enable underline:
    accountsRows.forEach((account) => {
      account.style.borderBottom = "1px solid #c8c8c8";
      account.style.padding = "10px 0";
    });
    //disable middle part of pagination:
    const middlePaginationTexts = [...document.querySelectorAll(".-center")];
    middlePaginationTexts.forEach((middlePaginationText) => {
      middlePaginationText.style.display = "none";
    });
    //add margin for previous and next buttons:
    const previousButtonTop = document.querySelector(".pagination-top .-previous");
    const nextButtonTop = document.querySelector(".pagination-top .-next");
    const previousButtonBottom = document.querySelector(".pagination-bottom .-previous");
    const nextButtonBottom = document.querySelector(".pagination-bottom .-next");
    if (previousButtonTop !== null) previousButtonTop.style.margin = "0 10px 15px 0";
    if (nextButtonTop !== null) nextButtonTop.style.margin = "0 0 15px 10px";
    if (previousButtonBottom !== null) previousButtonBottom.style.margin = "15px 10px 0 0";
    if (nextButtonBottom !== null) nextButtonBottom.style.margin = "15px 0 0 10px";
  };

  onChangeToDesktopView = () => {
    const tableHeader = document.querySelector(".rt-tr");
    if (tableHeader !== null) {
      tableHeader.style.display = "flex";
    }
    const accounts = [...document.querySelectorAll(".ReactTable .rt-table .rt-tbody .rt-tr-group .rt-tr")];
    //disable underline:
    accounts.forEach((account) => {
      account.style.borderBottom = "0";
      account.style.padding = "0";
    });
    //enable middle part of pagination:
    const middlePaginationTexts = [...document.querySelectorAll(".-center")];
    middlePaginationTexts.forEach((middlePaginationText) => {
      middlePaginationText.style.display = "initial";
    });
    //delete margin for previous and next buttons:
    const previousButtonBottom = document.querySelector(".pagination-bottom .-previous");
    const nextButtonBottom = document.querySelector(".pagination-bottom .-next");
    if (previousButtonBottom !== null) previousButtonBottom.style.margin = "0";
    if (nextButtonBottom !== null) nextButtonBottom.style.margin = "0";
  };

  notificationOk(e, data) {
    e.preventDefault();
    this.props.confirmNotification(data);
  }

  systemFilter() {
    const { classes, systems } = this.props;
    const sortedSystems = [...systems].sort((a, b) => (a.name.toLowerCase() > b.name.toLowerCase()) ? 1 : -1);

    return (
      <>
        <InputLabel htmlFor="simple-select" className={classes.selectLabel}>
          Filter by system
        </InputLabel>
        <Select
          classes={{ select: classes.select }}
          inputProps={{
            name: "devices",
            id: "avaiable-devices",
            autoCapitalize: "off",
          }}
          value={this.state.pickedSystemId}
          onChange={(e) => {
            const newValue = e.target.value;
            const searchParams = new URLSearchParams(this.props.location.search);
            if (newValue && newValue != "all") {
              searchParams.set('system', newValue);
            } else {
                searchParams.delete('system');
            }
            this.props.history.push(`${this.props.location.pathname}?${searchParams.toString()}`);
            this.setState({ pickedSystemId: newValue });
          }}
          style={{ minWidth: "30%" }}
        >
          <MenuItem classes={{ root: classes.selectMenuItem }} value={"all"}>
            All
          </MenuItem>
          {sortedSystems.map((sys) => {
            return (
              <MenuItem key={`MenuItem-${sys.ID}`} value={sys.ID}>
                {sys.name}
              </MenuItem>
            );
          })}
        </Select>
        <br />
        <br />
      </>
    );
  }

  setPageSize = () => {
    const { accounts, mobileView } = this.props;
    const { currentDesktopTableSize, mobileTableSize } = this.state;

    if (mobileView) {
      if (!accounts.length) {
        return 1;
      } else if (accounts.length < mobileTableSize) {
        return accounts.length;
      } else {
        return mobileTableSize;
      }
    } else {
      return currentDesktopTableSize;
    }
  };

    showUnbindFromSystemConfirmation = (accountId, accountName, accountLastSystem) => {
      const systemNamesByIds = Object.fromEntries(this.props.systems.map(x => [x.ID, x.name]));
      console.log('showUnbindFromSystemConfirmation', accountId, accountName, accountLastSystem);
      let alert = 
        <SweetAlert
          showConfirm={false}
          style={sweetAlertStyle}
          onConfirm={() => this.setState({alert: null})}
          onCancel={() => this.setState({alert: null})}
          title={''}
          key='unbind-user-sweet-alert'
        >
          <UnbindFromSystem
            systemName={systemNamesByIds[this.state.pickedSystemId]}
            hidePopup={() => this.setState({alert: null})}
            accountID={accountId}
            accountName={accountName}
            systemID={this.state.pickedSystemId}
            detachAccountFromSystemByID={this.props.detachAccountFromSystemByID}
            handleIsUserDetachedFromSystem={() => console.log('detached')}
            mobileView={this.props.mobileView}
            lastSystem={accountLastSystem}
          />
        </SweetAlert>;
      this.setState({alert: alert});
    };
  render() {
    let { classes, accounts, mobileView, login, systems } = this.props;
    const { pickedSystemId, alert } = this.state;
    const currentPageSize = this.setPageSize();
    if (pickedSystemId !== "all" && pickedSystemId !== undefined) {
      accounts = accounts.filter((a) => _.indexOf(a.systems, pickedSystemId) >= 0);
    }

    if (this.props.isAccountsLoading) {
      return (
        <GridContainer>
          <GridItem xs={12}>
            <Card>
              <CardHeader color="primary" icon>
                <CardIcon color="primary">
                  <Accounts />
                </CardIcon>
                <h4 className={classes.cardIconTitle}>Accounts</h4>
              </CardHeader>
              <div style={loaderStyleEmptyCard}>
                <Loading transform={0.85} height={90} width={70} color="gray" />
              </div>
            </Card>
          </GridItem>
        </GridContainer>
      );
    } else {
      return (
        <div data-testid="AccountsReactTable">
          {alert}
          <GridContainer className="accounts-page">
            <GridItem xs={12}>
              <Card>
                <CardHeader color="primary" icon>
                  <div style={{ display: "flex" }}>
                    <CardIcon color="primary">
                      <Accounts />
                    </CardIcon>
                    <h4 className={classes.cardIconTitle} style={{ flexGrow: "1" }}>
                      Accounts
                    </h4>
                  </div>
                </CardHeader>
                <CardBody>
                  {this.systemFilter()}
                  <ReactTable
                    data={accounts.map((account) => {
                      let actions = () => {
                        if (login.accountCategory === "observer") {
                          if (login.loggedUserId === account.id) {
                            return (
                              <NavLink to={{pathname:`/accounts/${account.id}/edit_account`, state:{ from: this.props.location.pathname + this.props.location.search }}}>
                                <IconButton
                                  size="small"
                                  data-testid={`accountDetails-${account.name}`}
                                >
                                  <UserDetails />
                                </IconButton>
                              </NavLink>
                            );
                          }
                        } else {
                          if (account.accessRightToAccount.Valid && account.accessRightToAccount.String !== "none") {
                            if (pickedSystemId !== "all" &&
                                (account.accountCategory == "commoner" || account.accountCategory == "installer") && 
                                (account.accessRightToAccount.String == "partial" || account.accessRightToAccount.String == "full")) {
                              const lastSystem = account.systems.indexOf(',') > -1;
                              return (
                                <>
                                  <NavLink to={{pathname:`/accounts/${account.id}/edit_account`, state:{ from: this.props.location.pathname + this.props.location.search }}}>
                                  <IconButton
                                    size="small"
                                    data-testid={`accountDetails-${account.name}`}
                                  >
                                    <UserDetails />
                                  </IconButton>
                                </NavLink>
                                 <Tooltip title="Unbind from system">
                                  <IconButton onClick={() => this.showUnbindFromSystemConfirmation(account.id, account.name, lastSystem)}>
                                    <LinkOff />
                                  </IconButton>
                                </Tooltip>
                                </>
                            );
                                }
                            return (
                              <NavLink to={{pathname:`/accounts/${account.id}/edit_account`, state:{ from: this.props.location.pathname + this.props.location.search }}}>
                                <IconButton
                                  size="small"
                                  data-testid={`accountDetails-${account.name}`}
                                >
                                  <UserDetails />
                                </IconButton>
                              </NavLink>
                            );
                          }
                        }
                      };
                      return {
                        name: account.name,
                        email: account.email,
                        phone: account.phone.String,
                        actions: actions(),
                      };
                    })}
                    filterable={!mobileView ? true : false}
                    columns={mobileView ? mobileColumns : desktopColumns}
                    pageSize={currentPageSize}
                    showPaginationTop={!mobileView ? false : true}
                    showPaginationBottom={true}
                    className={mobileView ? "-striped -highlight accountsMobileView" : "-striped -highlight"}
                    onFetchData={(data) => {
                      if (mobileView) {
                        this.onChangeToMobileView();
                      }
                    }}
                  />
                </CardBody>
              </Card>
            </GridItem>
          </GridContainer>
        </div>
      );
    }
  }
}

const mapStateToProps = (state) => {
  return {
    accounts: state.dashboard.accounts,
    systems: state.dashboard.systems,
    isAccountsLoading: state.dashboard.isAccountsLoading,
    login: state.login,
    mobileView: state.dashboard.mobileView,
  };
};

const actions = {
  accountsLoading,
  accountsLoaded,
  getVisibleAccounts,
  detachAccountFromSystemByID,
  getSystems2
};

export default connect(mapStateToProps, actions)(withRouter(withStyles(extendedTablesStyle)(AccountsReactTable)));
